// Toggle switch reusable estilo iOS.
// Props:
//   checked   (bool)        — estado actual
//   onChange  (fn)          — callback(newValue) al hacer click
//   disabled  (bool)        — true para deshabilitar
//   labelOn   (string)      — texto al lado cuando checked=true (default "Activa")
//   labelOff  (string)      — texto al lado cuando checked=false (default "Inactiva")
//   title     (string)      — tooltip al hover
//
// Uso típico:
//   <Toggle
//     checked={campaign.status === 'active'}
//     onChange={(next) => handleToggle(next)}
//     labelOn="Activa"
//     labelOff="Inactiva"
//   />

export default function Toggle({
  checked,
  onChange,
  disabled = false,
  labelOn = 'Activa',
  labelOff = 'Inactiva',
  title,
}) {
  const handleClick = () => {
    if (disabled) return
    onChange(!checked)
  }

  const switchCls = [
    'relative inline-flex h-6 w-11 items-center rounded-full transition-colors',
    disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
    checked ? 'bg-emerald-500' : 'bg-gray-300',
  ].join(' ')

  const knobCls = [
    'inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform',
    checked ? 'translate-x-5' : 'translate-x-1',
  ].join(' ')

  const labelCls = checked
    ? 'text-sm font-medium text-emerald-700'
    : 'text-sm font-medium text-gray-500'

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={handleClick}
      className="flex items-center gap-2 px-2 py-1 rounded-xl hover:bg-gray-50 transition"
      title={title}
    >
      <span className={switchCls}>
        <span className={knobCls} />
      </span>
      <span className={labelCls}>{checked ? labelOn : labelOff}</span>
    </button>
  )
}
